import React from "react";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { t } from "../../../../core/translate";
import { ThemedStyledButton } from "./styles";
import { StoreCircle } from "./icons";
import { navigateTo, navigateSafelyTo } from "../menu-items/shared";

const Store = ({ label, show, sso, url }) =>
  show ? (
    <ThemedStyledButton
      iconStart={<StoreCircle color="white" />}
      naked
      onClick={event => {
        const navigationFunc = sso ? navigateTo : navigateSafelyTo;
        navigationFunc(event, url, "header/store");
      }}
    >
      {label}
    </ThemedStyledButton>
  ) : null;

const mapStateToProps = state => ({
  show: brandSelectors.getBrandValue(state, "Store.visible"),
  label: brandSelectors.getBrandValue(
    state,
    "Store.label",
    t("global-bar.store", "Store")
  ),
  sso: brandSelectors.getBrandValue(state, "Store.sso"),
  url: brandSelectors.getBrandedCustomButtonUrl(state, {
    utm_medium: "bookshelf-nav"
  })
});

export default connect(mapStateToProps, null)(Store);
